// extracted by mini-css-extract-plugin
export default {"root":"Chip_root--rpg","delIcon":"Chip_delIcon--yfA"};